import { render, staticRenderFns } from "./MlbScoring.vue?vue&type=template&id=6f86912b&scoped=true"
import script from "./MlbScoring.vue?vue&type=script&lang=js"
export * from "./MlbScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86912b",
  null
  
)

export default component.exports